module.exports = __webpack_public_path__ + "media/images/products/cards/fundamental_pass-ec90bb4cbec68458fbf470c7cbb41b8d.png";